// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import React, {PropTypes} from 'react';
import {
    getCorrectDateValue,
    transformDateValue
} from '../../../../shared/services/build-date';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import WarrantyDatePicker from '../../../../shared/components/warranty-date-picker';

const handleLastContactDateChange = props => newDate => props.onItemChange('lastContactDate', getCorrectDateValue(newDate));

const LastPersonalContact = props =>
    <div className='labeled-string'>
        <span className='data-label'>
            <sup>{'*'}</sup> <FormattedMessage id='LAST_PERSONAL_CONTACT'/>
        </span>
        <WarrantyDatePicker
            onChange={handleLastContactDateChange(props)}
            selected={transformDateValue(props.statusChangeRequest.lastContactDetails.lastContactDate)}
        />
    </div>;

LastPersonalContact.displayName = 'LastPersonalContact';
LastPersonalContact.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default LastPersonalContact;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/last-personal-contact.js